import { useState, useEffect, useCallback, useRef } from "react";
import { Badge } from "@/components/ui/badge";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Clock, Loader2 } from "lucide-react";
import POSHeader from "./POSHeader";

export default function PedidosView({ authAxios, onBack }) {
  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchOrders = useCallback(() => {
    authAxiosRef.current.get("/orders?limit=50")
      .then(res => setOrders(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchOrders();
    const interval = setInterval(fetchOrders, 5000);
    return () => clearInterval(interval);
  }, [fetchOrders]);

  const statusLabels = { pending: "Pendente", preparing: "Preparando", ready: "Pronto", delivered: "Entregue", awaiting_payment: "Aguardando" };
  const statusColors = { pending: "bg-yellow-100 text-yellow-700", preparing: "bg-blue-100 text-blue-700", ready: "bg-emerald-100 text-emerald-700", delivered: "bg-gray-100 text-gray-500", awaiting_payment: "bg-orange-100 text-orange-700" };

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex flex-col" data-testid="pos-pedidos">
      <POSHeader title="Pedidos" icon={Clock} onBack={onBack} />
      <ScrollArea className="flex-1 p-3">
        {loading ? (
          <div className="text-center py-12"><Loader2 className="w-6 h-6 animate-spin mx-auto text-emerald-600" /></div>
        ) : orders.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            <Clock className="w-10 h-10 mx-auto mb-2 opacity-30" />
            <p>Nenhum pedido hoje</p>
          </div>
        ) : (
          <div className="space-y-2 max-w-lg mx-auto">
            {orders.map(o => (
              <div key={o.id} className="bg-white rounded-xl border p-3 flex items-center gap-3" data-testid={`pedido-${o.id?.slice(-6)}`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-0.5">
                    <span className="font-bold text-xs">#{o.order_number || o.id?.slice(-6).toUpperCase()}</span>
                    <Badge className={`text-[9px] ${statusColors[o.status] || "bg-gray-100"}`}>{statusLabels[o.status] || o.status}</Badge>
                    {o.source && <Badge className="text-[9px] bg-gray-50 text-gray-400 border">{o.source}</Badge>}
                  </div>
                  <p className="text-[11px] text-gray-500">{o.customer_name || "Venda Direta"} - {(o.items || []).length} itens</p>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="text-base font-bold text-emerald-600">{(o.total || 0).toFixed(2)}</p>
                  <p className="text-[9px] text-gray-400">{o.payment_method || ""}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </ScrollArea>
    </div>
  );
}
